import React from 'react'

import Img, { getImageUrl, Sizes } from '../components/blocks/editable/Img'

import { Helmet } from "react-helmet";

import InnerHTML from "dangerously-set-html-content";
import {InView} from "react-intersection-observer";

import Div from '../components/layouts/Div'

import General from '../utils/General'
import Backend from '../utils/Backend'
import ScriptCache from '../utils/ScriptCache'
import CartUtil from '../utils/Cart'
import Currency from '../utils/Currency'
import Notify from '../utils/Notify'
import Navigation from "../utils/Navigation";
import ProductSettingsModal from "../components/modal/ProductSettingsModal";
import {RotatingLines} from "react-loader-spinner";
import Event from "../utils/Event";
import BadgeBlock from "../components/BadgeBlock";

export default class Cart extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      key: 0,
      quantity: 1,
      cart: props.cart,
      website: props.website,
      editable: props.editable,
      error: null,
    }

    this._updateWebsite = General.debounce(
      () => {
        Backend.updateWebsite({
          slug: this.state.website.slug,
          extra: this.state.website.extra,
          checkout_type: this.state.website.checkout_type,
        });
      },
      1000,
      false
    );
  }

  componentDidMount() {
    this._setup()
    Event.on('WEBSITE_UPDATED', () => {
      this.setState({
        website: window.CURRENT_WEBSITE
      })
    });
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      ...nextProps,
      error: null
    })
  }

  _setup(){
    let {
      website,
    } = this.state

    if(website.extra?.product_page_settings?.cart_page_product){
      this._loadProduct(website.extra?.product_page_settings?.cart_page_product.productId)
    }

    this._loadJs()
  }

  _loadProduct(productId){
    this.setState({ loading: true })
    Backend.getProducts(productId).then(products => {
      let featuredProduct = products[0]
      let variantOptions = CartUtil.getOptions(featuredProduct)
      let customMessageOptions = CartUtil.getCustomMessageOptions(featuredProduct)
      this.setState({variantOptions, featuredProduct, customMessageOptions, loading: false}, () => this._loadJs())
    })
  }

  _loadJs(){
    ScriptCache.loadDefaults()
    setTimeout(() => {
      General.updateAll()
    }, 300)
  }

  _update(website, callback) {
    let pageSize = website.extra?.product_page_settings?.product_page_count || this.state.pageSize;
    this.setState({ website, pageSize }, () => {
      if (callback) {
        callback();
      }
      this._updateWebsite();
    });
  }

  async _onDashboardClicked() {
    this.setState({savingPage: true})
    await Backend.savePage();
    window.open(`${window.General.ApplicationUrl}/editfunnel/${window.CURRENT_WEBSITE.funnel_reference_id}`, "_self");
  }

  _renderCartItems(cart){

    const currency = cart.campaign?.currencySymbol

    if(!cart) return null

    return cart.items.map((item, index) => {
      let variantDetailId = item.ccCartKey.split('.')[1]
      let product = item.product
      let quantity = item.quantity
      let frequency = item.frequency

      if(!product) return

      let price = product.cycle1_price

      let variant = product.variants?.find(productVariant => {
        return productVariant.variantDetailId === parseInt(variantDetailId)
      })

      if(variant && variant.price) {
        price = variant.price
      }

      return (
        <div className="product-item py-5">
          <div className="row">
            <div className="col-8">
              <div className="d-flex align-items-center">
                <div className="img m-0" style ={{ backgroundImage: "url("+product.imageUrl+")" }} />
                <div className="ml-3">
                  <a
                    className="m-0 h5 title"
                    href={Navigation.getProductUrl(product.campaignProductId)}
                  >
                    {product.productName}
                  </a>
                  {
                    variant &&
                    <div className="variant">Variant: {variant.title}</div>
                  }
                  {
                    item.customMessage?.map(customMessage => {
                      let [key, value] = customMessage.split(':')
                      return (
                        <div className="quantity">{General.toTitleCase(key)}: {value}</div>
                      )
                    })
                  }
                  {
                    item.frequency &&
                    <div className="quantity">Frequency: {General.toTitleCase(item.frequency)}</div>
                  }
                </div>
              </div>
            </div>
            <div className="col d-flex align-items-center justify-content-between">
              <div className="input-number col-auto p-0">
                <input
                  type="number"
                  name="quantity"
                  placeholder="Quantity"
                  value={quantity}
                  min="1"
                />
                <div className="input-number__controls">
                <span
                  className="input-number__increase"
                  onClick={() => {
                    CartUtil.add(product, variant, item.customMessage, 1, frequency)
                      .then((cart) => {
                        this.setState({ cart });
                        this.props.onUpdatedCart(cart);
                      })
                      .catch((error) => {
                        Notify.error(error.message);
                      });
                  }}
                >
                  <i className="stack-up-open"/>
                </span>
                  <span
                    className="input-number__decrease"
                    onClick={() => {
                      CartUtil.remove(product, variant, item.customMessage, 1, frequency)
                        .then((cart) => {
                          this.setState({ cart });
                          this.props.onUpdatedCart(cart);
                        })
                        .catch((error) => {
                          Notify.error(error.message);
                        });
                    }}
                  >
                  <i className="stack-down-open"/>
                </span>
                </div>
              </div>
              <div className="col-2 p-0 delete text-center">
                <a
                  href="javascript:void(0);"
                  className="material-icons"
                  onClick={() => {
                    CartUtil.remove(product, variant, item.customMessage, quantity, frequency)
                      .then((cart) => {
                        this.setState({ cart });
                        this.props.onUpdatedCart(cart);
                      })
                      .catch((error) => {
                        Notify.error(error.message);
                      });
                  }}
                >
                  delete
                </a>
              </div>
              <span className="col p-0 text-right price">{ Currency.toFormat(item.total) }</span>
            </div>
          </div>
        </div>
      )
    })
  }

  _renderCart(){
    let {
      cart,
      website
    } = this.state

    const currency = cart.campaign?.currencySymbol

    return (
      <div key={cart.items.length} className="col-md-12 col-left">
        <div className="row">
          <div className="col-md-12">
            <div className="cart-total m-0">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <h2 className="mb-0">Your Cart</h2>
                </div>
                <div>
                  <a
                    href={Navigation.getUrl('/')}
                    className="text-dark cursor-pointer"
                    style={{
                      textDecoration: 'underline',
                    }}
                  >
                    Continue Shopping
                  </a>
                </div>
              </div>

              { this._renderCartItems(cart) }
              <hr />
              <div className="row m-md-b-0">
                <div className="col-6"/>
                <div className="col-6 d-flex align-items-center justify-content-end text-right">
                  <span className="h3 mb-0 mr-3">Estimated Total</span>
                  <span className="h4 mb-0">{ Currency.toFormat(cart.subtotal) }</span>
                </div>
              </div>
              <div className="row m-md-b-0 mt-2">
                <div className="col-6"/>
                <div className="col-6 text-right">
                  {
                    cart.items.length > 0 &&
                    <a
                      className="btn btn--primary type--uppercase btn--lg"
                      onClick={() => {
                        const url = website.extra?.product_page_settings?.checkout_url
                        if(!url) {
                          Notify.error("Checkout url not set, please contact the site owner")
                        }else if(window.IS_EDIT_MODE){
                          Notify.error("Checkout disabled in edit mode")
                        }else if(url) {
                          window.location = Navigation.getUrl(url)
                        }
                      }}
                    >
                      <span className="btn__text">Checkout</span>
                    </a>
                  }
                </div>
              </div>
              <div className="row m-md-b-0 mt-2">
                <div className="col-6"/>
                <div className="col-6 text-right">
                  <span className="h5 font-weight-light">Taxes and shipping calculated at checkout</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _renderMeta(){
    let {
      website
    } = this.state

    let favIconUrl = website.favicon ? website.favicon.original : "/favicon.ico"

    return (
      <Helmet>
        <title>{`Cart | ${website.name}`}</title>
        <meta name="description" content={ website.description } />
        <meta name="keywords" content={ website.keywords } />
        <link rel="icon" href={ favIconUrl }/>
      </Helmet>
    )
  }

  _renderProductSettingsButton() {
    let {
      editable,
      savingPage
    } = this.state;

    if (!editable) {
      return;
    }

    let className = "btn-fixed-left-container ignore-user-set-font";

    return (
      <div className={className}>

        <div className="d-flex">
          <button
            className="btn"
            title="Back to Funnel"
            onClick={() => this._onDashboardClicked()}
          >
            <span className="btn__text">
              {
                savingPage ?
                  <RotatingLines
                    height={24}
                    width={"24"}
                    strokeColor={"#ffffff"}
                  />
                  :
                  <span className="material-icons">arrow_back_ios_new_outlined</span>
              }
              <span className="slide-text">Back to Funnel</span>
            </span>
          </button>
        </div>

        {/* Starts : Button 01 */}
        <div className="d-flex">
          <a
            className="btn styling-button"
            title="Cart Settings"
            onClick={() => this.setState({ showProductSettingsModal: true })}
          >
            <span className="btn__text">
              <span class="material-icons">brush_outline</span>
              <span class="slide-text">Cart Settings</span>
            </span>
          </a>
        </div>
        {/* End : Button 01 */}

      </div>
    );
  }

  _renderPrice(product) {
    let { website } = this.state;

    if (!product) {
      return "";
    }

    let price = product.cycle1_price
    let currency = window.CURRENT_CAMPAIGN?.currencySymbol

    if (product.on_sale) {
      return (
        <>
          <span
            className="h3 type--strikethrough m-0 pr-1"
            style={{ color: website.secondary_color }}
          >
            {Currency.toFormat(price)}
          </span>
          <span
            className="h3 m-0 pr-2"
            style={{ color: website.secondary_color }}
          >
            {Currency.toFormat(price)}
          </span>
        </>
      );
    }

    if(product.variants.length > 0){
      if(product.variants[0].price){
        price = product.variants[0].price
      }
    }

    return (
      <span
        className="h3 m-0 pr-2"
        style={{ color: website.secondary_color }}
      >
        {Currency.toFormat(price)}
      </span>
    );
  }

  render(){
    let {
      key,
      quantity,
      website,
      featuredProduct,
      variantOptions,
      customMessageOptions
    } = this.state;

    let images = [{original: featuredProduct?.imageUrl}]

    let showAddCart = (variantOptions && Object.entries(variantOptions).length < 1) && (customMessageOptions && customMessageOptions.length < 1)

    let cartButtonText = "Add To Cart"
    if(window.CURRENT_WEBSITE.checkout_type === "instant"){
      cartButtonText = "Buy Now"
    }

    return (
      <>
        <div className="main-container page product">
          { this._renderMeta() }
          <section className="cart-customer-details cart-checkout m-0">
            <Div
              className="container"
            >
              <div className="row justify-content-around">
                { this._renderCart() }
              </div>
            </Div>
          </section>
          {featuredProduct && (
            <section
              className="section block-37 pt-0 switchable"
            >
              <div className="container">
                <div className="row justify-content-around">
                  {/* starts, column right  */}
                  <div className="col-md-5 col-lg-5">
                    <h2 style={{ color: website.primary_color }}>
                      {featuredProduct.productName}
                    </h2>
                    <div className="text-block d-flex align-items-center pb-3">
                      {this._renderPrice(featuredProduct)}
                      {featuredProduct.on_sale && (
                        <span className="label position-static product-sale-price">
                          Sale
                        </span>
                      )}
                    </div>
                    <div
                      className="lead pre"
                      style={{ color: website.secondary_color }}
                      dangerouslySetInnerHTML={{
                        __html: featuredProduct.productDescription,
                      }}
                    />
                    <div>
                      {
                        showAddCart ?
                          <a
                            className="btn btn--secondary mb-2 w-100"
                            onClick={() =>this.props.onAddToCartPressed(featuredProduct, null, [], quantity)}
                          >
                            <span className="btn__text">{cartButtonText}</span>
                          </a>
                        :
                          <a
                            className="btn btn--secondary mb-2 w-100"
                            href={Navigation.getProductUrl(featuredProduct.campaignProductId)}
                          >
                            <span className="btn__text">More Details</span>
                          </a>
                      }
                    </div>
                  </div>
                  <div className="col-md-7 col-lg-6">
                    <div className="position-relative">
                      <div
                        key={key}
                        className="slider border--round boxed--border"
                        data-paging="true"
                        data-arrows="true"
                      >
                        <ul className="slides">
                          {images.map((image) => {
                            return (
                              <li
                                key={image.id}
                                style={{
                                  backgroundImage:
                                    "url(" + getImageUrl(image, 37) + ")",
                                }}
                              ></li>
                            );
                          })}
                        </ul>
                      </div>
                      <BadgeBlock product={featuredProduct} />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {
            website.extra.product_page_settings.cart_page_html &&
            <>
              {
                website.extra.product_page_settings.cart_page_html_lazy_load &&
                <InView
                  triggerOnce={true}
                >
                  {({ inView, ref, entry }) => (
                    <div ref={ref}>
                      { inView &&
                        <InnerHTML html={website.extra.product_page_settings.cart_page_html}/>
                      }
                    </div>
                  )}
                </InView>
              }

              {
                !website.extra.product_page_settings.cart_page_html_lazy_load &&
                <section className="block-54 text-center">
                  <div className="container">
                    <InnerHTML html={website.extra.product_page_settings.cart_page_html}/>
                  </div>
                </section>
              }
            </>
          }
        </div>
        {this._renderProductSettingsButton()}
        <ProductSettingsModal
          show={this.state.showProductSettingsModal}
          website={website}
          onCheckoutTypeUpdated={(checkoutType) => {
            website.checkout_type = checkoutType
            this._update(website)
          }}
          onUpdated={(data) => {
            if(!website.extra){
              website.extra = {product_page_settings: null}
            }
            website.extra.product_page_settings = data
            this._update(website, () => this._setup())
          }}
          onHide={() => this.setState({showProductSettingsModal: false})}
        />
        <div id="notification-container" class="text-center">
          <div id="notification-content"></div>
        </div>
      </>
    )
  }
}
